export const statisticProcessTransfers: TableModule = {
    name: "statisticProcessTransfers",
    route: "spa.statistics.statisticProcessTransfers",
    columns: [
        {
            name: "id",
            sortable: true,
            pageLink: true,
            mobile: true,
            width: "w-20"
        }, {
            name: "association",
            sortable: true,
            sortBy: "organisations.name",
            mobile: true
        }, {
            name: "year_id",
            sortable: true,
            mobile: true
        }, {
            name: "mode",
            sortable: true,
        }, {
            name: "transfer_status",
        }, {
            name: "created_at",
        }
    ],
    filters: [],
    quickFilters: [],
    tools: []
}